import { dateFormatPayload } from "src/views/pages/targetting/date.constant";

export const createMasterSearchPayload = (targetingFilter) => {
    return targetingFilter.map((item) => {
        return {
          "level": item.level,
          "condition": "and",
          ...(item.selected_option != '' ?  { "type": item.selected_option } : ''),
          ...(item?.statusTypes ? {
            status_types: Object.keys(item?.statusTypes).filter(key => item?.statusTypes[key] !== '').reduce((acc, key) => {
              acc[key] = item?.statusTypes[key];
              return acc;
            }, {})
          } : !(item?.compareMode && item?.compareMetric) ? { 
            "keywords": item.keyword, 
            ...( window.location.href.indexOf('/amazon/targeting') > -1 ? item.customType === 'parent' ? { is_asin_parent: 1, search_parent_asin : true } : { is_asin_parent: 0, search_parent_asin : false } : {})
          } : {}),
          ...(item.level === 'hour' && item.filterFieldMap && {
            "FilterField": item.keyword.map(keyword => item.filterFieldMap[keyword]).filter(val => val !== undefined)
          }),
          ...(item.level === 'CampaignState' && item?.budgetStatus?.length > 0 ? {
            budgetStatus: item.budgetStatus
          } : {}),
          ...(item.level === 'CampaignDate' ? {
            dates: {
              start: dateFormatPayload(item?.dates?.startDate),
              end: dateFormatPayload(item?.dates?.endDate) 
            }
          } : {}),
          ...(item.level === 'KeywordHarvesting' ? {
            harvest_type: String(item.harvestOptionSelected),
            matchType: item.matchTypeSelected,
            ...(item.customKeyword != '' && item.customTypeSelected?.length > 0 ? {
              custom: {
                type: String(item.customTypeSelected),
                keywords: item.customKeyword
              }
            } : {})
          } : {}),
          ...(item.level === 'AsinHarvesting' ? {
            harvest_type: String(item.harvestOptionSelected),
            matchType: item.matchTypeSelected,
            ...(item.customKeyword != '' && item.customTypeSelected?.length > 0 ? {
              custom: {
                type: String(item.customTypeSelected),
                keywords: item.customKeyword
              }
            } : {}),
          } : {}),
          ...(item.tableInformation && item.tableInformation?.tableName ? {
            tableInfo: {
              table_name: item.tableInformation?.tableName,
              aggregate: item.tableInformation?.aggregate,
              ...(item?.tableInformation?.custom == true && item.tableInformation?.tableId ? {
                table_id: item.tableInformation?.tableId,
                report: item.tableInformation?.report_source || ""
              } : {})
            }
          } : {}),
          ...(item.compareMode && item.compareMetric ? {
            comparedTo: {
              level: item.compareMetric == 'Ad ACOS %' ? 'ACOS' : item.compareMetric,
            },
            ...(item?.comparePercentage != null && item?.comparePercentage !== '' && item?.comparePercentage !== undefined ? { percentage: parseFloat(item?.comparePercentage) } : {})
          } : {})
        }
      })
}

export const createSortReportPayload = (reportFilters) => {
  return reportFilters
}